import { render, staticRenderFns } from "./whatsapp.vue?vue&type=template&id=6eae32fd"
import script from "./whatsapp.vue?vue&type=script&lang=js"
export * from "./whatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports